import { render } from "./AccountRoleAddPanel.vue?vue&type=template&id=700ec418&scoped=true"
import script from "./AccountRoleAddPanel.vue?vue&type=script&lang=js"
export * from "./AccountRoleAddPanel.vue?vue&type=script&lang=js"

import "./AccountRoleAddPanel.vue?vue&type=style&index=0&id=700ec418&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-700ec418"

export default script